import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { tokenStorage } from './tokenStorage';

@Injectable()
export class Auth implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    if (tokenStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/core/auth.ts